import React, { Fragment } from 'react'

function Panel({ eyebrow, title, children, className }) {
  return (
    <Fragment>
        <div className={`panel${className ? ` ${className}` : ''}`}>
            <div className='panelHeader'>
                {eyebrow && <span className='eyebrow'>{eyebrow}</span>}
                <h3>{title}</h3>
            </div>
            <div className='panelBody'>
                {children}
            </div>
        </div>
    </Fragment>
  )
}

export default Panel
